export default {
  alert: {
    fontWeight: 300,
    mb: 4,
  },
  editCardHeader: {
    backgroundColor: 'background.light',
    borderRadius: '4px 4px 0 0',
    px: 2,
    py: 1.75,
  },
  editCardHeaderText: {
    color: 'text.dark',
    fontWeight: '400',
  },
  editCardBody: {
    border: '1px solid',
    borderColor: 'background.grey.blue_3',
    borderTop: 'none',
    display: 'flex',
    gap: 3,
    px: 2,
    py: 2.5,
  },
  checkcolor: {
    color: 'text.brand.color_2',
    padding: '3px',
  },
  sync: {
    pt: 2,
    display: 'flex',
    alignItems: 'center',
  },
};
